<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.reportsPartnersRealestate')}}</b></span><br><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md2 xs12 text-md-left text-xs-right>
				<Dropdown
					v-model="partners"
					:ajax="true"
					:data="'partners'"
					:label="'* '+$t('labels.reportsPartner')"></Dropdown>
			</v-flex>
			<v-flex md10 xs12 text-md-right text-xs-right>
				<v-tooltip bottom>
				<v-btn @click="excelExport" icon slot="activator">
					<v-icon small>fa-file-excel</v-icon>
				</v-btn>
				<span>{{$t('tooltips.excel')}}</span>
			</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap pt-3>
			<v-flex xs12>
				<DataTableContacts
						:excel="false"
						:filter="false"
						:headers="contactsTable.headers"
						:items="contactsTable.items"
						:total="contactsTable.total"
						@reload="reloadData"
						@excel="excelExport"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.link, false)">{{ props.item.realestate_id }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.date }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.client_no }}</td>
							</tr>
						</template>
					</DataTableContacts>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import Dropdown from "./trinkets/Dropdown";
import DataTableContacts from "./trinkets/DataTableContacts";

export default {
	name: "ReportsPartnersRealestate",
	components: {DataTableContacts, Dropdown},
	data: function () {
		return {
			contactsTable: {
				headers: [
					{text: this.$t('fields.realestateId'), value: 'realestate_id', type: 'string', searchable: false},
					{text: this.$t('labels.realestateDownloadTime'), value: 'date', type: 'string', searchable: false},
					{text: this.$t('fields.clientNo'), value: 'client_no', type: 'string', searchable: false}
				],
				items: [],
				total: 0,
				lastRequest: null,
			},
			partners: null
		}
	},
	watch: {
		partners: {
			handler: function () {
				console.log('mijenjam partnera');
				this.reloadData();
			},
			deep: true
		},
	},
	methods: {
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			let data = {
				request: this.lastRequest,
				partner: this.partners
			}
			this.$APICall('get', 'report-partner-realestate', data, (data, success) => {
				if (success) {
					vm.contactsTable.items = data.items;
					vm.contactsTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		excelExport() {
			if(this.contactsTable.items != undefined && this.contactsTable.items != null){
				if(this.contactsTable.items.length != 0){
					this.$APICall('post', 'excel/report-partner-realestate', this.contactsTable.items, (data, success) => {
						window.open(data.link);
					});
				}
			}
		},
		editClick(link){
			if(link != null && link != ''){
				window.open(link);
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
		this.reloadData();
	}
}
</script>

<style scoped>

</style>
